import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import Auth from '@Services/Auth';
import { Modal } from '@els/els-react--modal';
import { paths } from '@AppRoutes/constants';
import LoginForm from './Components/LoginForm';

function LoginModal(props) {
  const { isAnonymousUser, cancel, closeModal, init, resetState } = props;
  const location = useLocation();
  const isInitialRender = useRef(true);

  const keyUpListener = (e) => {
    if (e && e.keyCode === 27 && isAnonymousUser) {
      cancel();
    }
  };

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    if (location.pathname === paths.LOGIN_ORGANIZATION) {
      closeModal();
    }
  }, [location.pathname]);

  useEffect(() => {
    if (isAnonymousUser === false && Auth.isReaxysAllowed()) {
      closeModal();
      return undefined;
    }

    init();
    document.addEventListener('keyup', keyUpListener);
    // eslint-disable-next-line consistent-return
    return () => {
      resetState();
      document.removeEventListener('keyup', keyUpListener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal label="Signin Modal" onClose={cancel} width="26.25rem" type="secondary" className="login-modal" shouldPreventClickOverlayToClose>
      <LoginForm {...props} />
    </Modal>
  );
}

LoginModal.propTypes = {
  isAnonymousUser: PropTypes.bool,
  cancel: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  init: PropTypes.func.isRequired,
  resetState: PropTypes.func.isRequired,
};

export default LoginModal;
